/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module core/modules/date-utils/parse-seconds */

/**
 * @typedef parseSecondsReturnType
 * @property {number} hours - Hours.
 * @property {number} minutes - Minutes.
 * @property {number} seconds - Seconds.
 */

/**
 * @description Transform seconds to an array of hours.
 * @param {number} seconds - Seconds.
 * @returns {parseSecondsReturnType} Parsed object.
 */
function parseSeconds(seconds) {
  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor(seconds % 3600 / 60),
    seconds: Math.floor(seconds % 3600 % 60)
  };
}

export { parseSeconds };